/**
 * Utility hooks and functions to handle migration from Next.js to React Router
 */

import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

/**
 * Replacement for Next.js useSearchParams
 * Returns URLSearchParams object compatible with Next.js API
 */
export function useSearchParams() {
  const location = useLocation();
  return new URLSearchParams(location.search);
}

/**
 * Replacement for Next.js useRouter
 * Provides navigate() method compatible with Next.js router.push()
 */
export function useRouter() {
  const navigate = useNavigate();

  return {
    push: (path: string) => navigate(path),
    replace: (path: string) => navigate(path, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
  };
}

/**
 * Replacement for Next.js usePathname
 */
export function usePathname() {
  const location = useLocation();
  return location.pathname;
}
